import { EscalationLevelConfig } from '../models/configuration-row';
import {
  SLAEscalationConfigurationResponse,
  SLAEscalationRuleResponse,
} from '../models/sla-escalation.model';
import {
  getEscalationLevelTitle,
  getTriggerHint,
  sortEscalationLevels,
} from './escalation-configuration.utils';

export function mapRuleToEscalationLevel(rule: SLAEscalationRuleResponse): EscalationLevelConfig {
  return {
    id: `rule-${rule.id}`,
    title: getEscalationLevelTitle(rule.escalation_level),
    escalationLevel: rule.escalation_level,
    triggerPercent: rule.trigger_time_percentage,
    triggerHint: getTriggerHint(rule.trigger_time_percentage),
    escalateTo: rule.escalate_to ?? [],
    alertRecipients: rule.alert_recipients ?? [],
    channels: {
      email: rule.notification_channels.includes('EMAIL'),
      sms: rule.notification_channels.includes('SMS'),
      phoneCall: rule.notification_channels.includes('PHONE_CALL'),
      pushNotification: rule.notification_channels.includes('PUSH_NOTIFICATION'),
    },
    isBreach: rule.is_breach_level,
    isActive: rule.is_active,
  };
}

export function mapConfigurationToState(response: SLAEscalationConfigurationResponse): {
  configuration: SLAEscalationConfigurationResponse;
  escalationEnabled: boolean;
  escalationLevels: EscalationLevelConfig[];
} {
  return {
    configuration: response,
    escalationEnabled: response.is_escalation_enabled,
    escalationLevels: sortEscalationLevels(
      response.rules.map((rule) => mapRuleToEscalationLevel(rule)),
    ),
  };
}
